import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-id.js';
import { GET_STORE_DETAILS } from '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-id.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';
import '../../types.js';
import { fromStoreQueryDataToStoreDetails } from './adapters/fromStoreQueryDataToStoreDetails.js';

const useStoreDetails = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_DETAILS, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        fetchPolicy: 'no-cache'
    });
    const data = React.useMemo(()=>{
        var ref;
        const storeQueryData = (ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store;
        return fromStoreQueryDataToStoreDetails(storeQueryData);
    }, [
        queryState.data
    ]);
    const getStoreDetails = React.useCallback((slugOrCode)=>{
        query({
            variables: {
                [typeof slugOrCode === 'string' ? 'slug' : 'code']: slugOrCode
            }
        });
    }, [
        query
    ]);
    React.useEffect(()=>{
        if (queryState.error) {
            console.error('Failed to fetch store details: ', queryState.error);
        }
    }, [
        queryState.error
    ]);
    return React.useMemo(()=>[
            getStoreDetails,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getStoreDetails,
        queryState,
        data
    ]);
};
const useStoreDetailsWithGlobalStoreId = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_DETAILS, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        fetchPolicy: 'no-cache'
    });
    const data = React.useMemo(()=>{
        var ref;
        const storeQueryData = (ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store;
        return fromStoreQueryDataToStoreDetails(storeQueryData);
    }, [
        queryState.data
    ]);
    const getStoreDetails = React.useCallback((globalStoreId)=>{
        query({
            variables: {
                globalStoreId
            }
        });
    }, [
        query
    ]);
    React.useEffect(()=>{
        if (queryState.error) {
            console.error('Failed to fetch store details: ', queryState.error);
        }
    }, [
        queryState.error
    ]);
    return React.useMemo(()=>[
            getStoreDetails,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getStoreDetails,
        queryState,
        data
    ]);
};

export { useStoreDetails as default, useStoreDetails, useStoreDetailsWithGlobalStoreId };
//# sourceMappingURL=use-store-details.js.map
